import React from 'react';
import DetentionsContent from './DetentionsContent';

function Detentions() {
    return (
        <div className='table-page'>
            <div className='container'>
                <h2>Vessel Detentions / Compliance</h2>
                <DetentionsContent />
            </div>
        </div>
    );
}

export default Detentions;



// WEBPACK FOOTER //
// ./app/components/Detentions/Detentions.jsx